import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import { elementActions } from "../../../../../store/actions/cms/element/element.action";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";

import { DragDropContext } from "react-beautiful-dnd";

import { Container } from "reactstrap";

import { AppAside, AppBreadcrumb, AppFooter, AppHeader, AppSidebar, AppSidebarFooter, AppSidebarForm, AppSidebarHeader, AppSidebarMinimizer, AppSidebarNav } from "@coreui/react";

//Lazy load this
import FormContent from "./FormContent";
import { languageActions } from "../../../../../store/actions/system/language/language.action";
import { arrayHelper } from "../../../../../helpers/arrayHelper";
import { securityHelper } from "../../../../../helpers/securityHelper";
import Notifier from "../../../../../components/UI/Notifier/Notifier";
import { elementConstants } from "../../../../../constants/cms/form/element/element.constants";
import { systemLabelActions } from "../../../../../store/actions/system/systemLabel/systemLabel.action";
import { containerHelper } from "../../../../helpers/containerHelper";
import { content } from "../../../../models/content";
import { contentHelper } from "../../../../helpers/contentHelper";
import { paymentHelper } from "../../../../helpers/paymentHelper";
import TemplateWrapper from "../../../template/containers/TemplateLayout/TemplateWrapper";
import { cmsActions } from "../../../../../store/actions/cms/cms.action";
import { sourceTypes } from "../../../../../constants/cms/sourceType";
import { SplashScreen } from "../../../../components/UI/SplashScreen/SplashScreen";
import { confirmationActions } from "../../../../../store/actions/confirmation/confirmation.action";
import { EditorToggler } from "../../../../components/UI/EditorToggler/EditorToggler";
import "../../../../style/EditorLayout.css";
import { deepClone } from "../../../../../helpers/objectHelper";
import { elementOrgin } from "../../../../helpers/elementHelper";
import ErrorBoundary from "../../../../../hoc/ErrorBoundry";
import { pageActions } from "../../../../../store/actions/cms/page/page.action";
import { preConfirmationHelper } from "../../../../helpers/preConfirmationHelper";
import EditorSidebar from "../../../../components/editor/EditorSidebar/EditorSidebar";
import { getKey } from "../../../../../helpers/UrlHelper";
import { emailActions } from "../../../../../store/actions/cms/email/email.action";
import { profileImageUploaderHelper } from "../../../../helpers/profileImageUploader.helper";
import { discountHelper } from "../../../../helpers/rebateHelper";
import { groupRegistrationHelper } from "../../../../helpers/groupRegistrationHelper";
import { fileUploadHelper } from "../../../../helpers/fileUploadHelper";

class FormLayout extends React.Component {
  state = {
    loaded: false,
    sidebarOpen: true,
    asideOpen: true,
    isSurvey: false,
    isConditionModalOpen: false,
    conditionAction: null,
    dragging: false,
  };
  loading = () => <div className="animated fadeIn pt-1 text-center">Loading...</div>;
  componentDidMount() {
    const { dispatch, user, match } = this.props;
    document.body.style.overflow = "hidden";
    if (user) {
      let eventId = null;
      let languageCode = null;
      if (window.location.search) {
        const params = new URLSearchParams(window.location.search);
        let unparsedEventId = params.get(getKey("eventId", params));
        if (unparsedEventId) eventId = parseInt(unparsedEventId);
        languageCode = params.get(getKey("languageCode", params));
      }
      if (user && !eventId) {
        eventId = user.eid === undefined ? user.token.eid : user.eid;
      }
      if (user && !languageCode) {
        languageCode = user.userLang === undefined ? user.token.userLang : user.userLang;
      }
      if (!languageCode) languageCode = "swe";

      dispatch(languageActions.getAllCodesByEvent(eventId));
      dispatch(templateActions.getAll(eventId, true));
      dispatch(cmsActions.setEnviroment(sourceTypes.FORM, true, eventId, languageCode));
      dispatch(emailActions.getByEvent(eventId));
      dispatch(formActions.getAllPaths(eventId));
      dispatch(pageActions.getAllPaths(eventId));
      dispatch(systemLabelActions.getGroup(languageCode, "Form.Edit"));
      dispatch(formActions.get(match.params.id, true));
    }
  }
  toggleConditionModal = (conditionAction) => {
    this.setState({
      isConditionModalOpen: !this.state.isConditionModalOpen,
      conditionAction,
    });
  };
  componentDidUpdate(prevProps) {
    if (prevProps.form !== this.props.form && this.props.form !== undefined && this.props.template.template === undefined) {
      if (this.props.form.survey == true && this.props.form.survey != this.state.isSurvey) {
        this.setState({ isSurvey: true });
      }
      const { dispatch } = this.props;

      //get temp from all templates that was loaded before!
      if (this.props.form.templateId) {
        dispatch(templateActions.get(this.props.form.templateId));
      }
      if (this.props.form.eventId > 0) {
        dispatch(elementActions.getAll(this.props.form.eventId));
      }
    }
    if (
      this.props.elements !== undefined &&
      this.props.form.formId > 0 &&
      /*   this.props.language.loading === false && */
      this.props.template.template !== undefined &&
      this.state.loaded === false
    ) {
      this.setState({ loaded: true });
    }
  }

  sortElements = (result) => {
    const { destination, source, draggableId } = result;
    const { dispatch, form } = this.props;
    const newForm = deepClone(form);

    const sourceEl = newForm.formElements.find((el) => {
      return el.contentId === draggableId;
    });

    if (destination.index > source.index) {
      //if moved down
      newForm.formElements.map((el) => {
        if (el.page === sourceEl.page && el.parentId === sourceEl.parentId && el.sortOrder > source.index && el.sortOrder <= destination.index) {
          el.sortOrder -= 1;
        }

        if (el.contentId === sourceEl.contentId) {
          el.sortOrder = destination.index;
        }
      });
    } else if (destination.index < source.index) {
      newForm.formElements.map((el) => {
        if (el.page === sourceEl.page && el.parentId === sourceEl.parentId && el.sortOrder <= source.index && el.sortOrder >= destination.index) {
          el.sortOrder += 1;
        }
        if (el.contentId === sourceEl.contentId) {
          el.sortOrder = destination.index;
        }
      });
    }

    dispatch(formActions.softUpdate(newForm));
  };
  moveElement = (result) => {
    const { destination, source, draggableId } = result;
    const { dispatch, form, elements, event } = this.props;

    const elementInfo = draggableId.split(":");

    const newForm = Object.assign({}, form);
    const newFormElements = Array.from(newForm.formElements);

    newFormElements.sort((a, b) => {
      let x = a.sortOrder;
      let y = b.sortOrder;
      return y < x ? 1 : y > x ? -1 : 0;
    });

    if (elements === undefined) {
      return;
    }
    let elementList = [];
    try {
      elementList = Array.from(elements);
    } catch (error) {
      return;
    }

    let element = elementList.find((el) => {
      return el.id === parseInt(elementInfo[1]) && el.type === parseInt(elementInfo[0]);
    });

    newFormElements.map((el) => {
      if (el.sortOrder >= destination.index && el.page == form.currentPage && el.parentId === null) el.sortOrder += 1;
    });
    // let destinationTrack = null;

    //If element is type of container it won't be loaded from the server and need to be
    //managed through the containerHelper service
    //We are adding possible multiple container that need to relate to one and other at the same time
    //adjusting the base container to the current form state.
    if (element === undefined && parseInt(elementInfo[0]) === elementConstants.CONTAINER) {
      let newContainerElements = containerHelper.create(newForm, "FORM", elementInfo[1], destination.index);
      newForm.formElements = newFormElements.concat(newContainerElements);
    
    } else if (element === undefined && parseInt(elementInfo[0]) === elementConstants.PAYMENT_OPTIONS) {
      let newPaymentElement = paymentHelper.create(newForm, "FORM", elementInfo[1], destination.index);
      newForm.formElements = newFormElements.concat(newPaymentElement);
    } else if (element === undefined && parseInt(elementInfo[0]) === elementConstants.PRE_CONFIRMATION) {
      let newPreConfiramtionElement = preConfirmationHelper.create(newForm, "FORM", elementInfo[1], destination.index);

      newFormElements.push(newPreConfiramtionElement);
      newForm.formElements = newFormElements;
    } else if (element === undefined && parseInt(elementInfo[0]) === elementConstants.PROFILEIMAGE_UPLOAD) {
      let newProfileImageUploader = profileImageUploaderHelper.create(newForm, "FORM", elementInfo[1], destination.index);

      newFormElements.push(newProfileImageUploader);
      newForm.formElements = newFormElements;
    } else if (element === undefined && parseInt(elementInfo[0]) === elementConstants.DISCOUNT) {
      let newRebate = discountHelper.create(newForm, "FORM", elementInfo[1], destination.index);

      newFormElements.push(newRebate);
      newForm.formElements = newFormElements;
    } 
    else if (element === undefined && parseInt(elementInfo[0]) === elementConstants.GROUP_REGISTRATION) {
      let newRebate = groupRegistrationHelper.create(newForm, "FORM", elementInfo[1], destination.index);

      newFormElements.push(newRebate);
      newForm.formElements = newFormElements;
    }
    else if (element === undefined && parseInt(elementInfo[0]) === elementConstants.FILE_UPLOADER) {
      let newFileUploader = fileUploadHelper.create(newForm, "FORM", elementInfo[1], destination.index);

      newFormElements.push(newFileUploader);
      newForm.formElements = newFormElements;
    }
    else if (element === undefined && parseInt(elementInfo[0]) === elementConstants.CONTENT) {
      const selectedEl = content.find((el) => {
        return el.id === elementInfo[1];
      });

      let contentElement = contentHelper.create(newForm, sourceTypes.FORM, selectedEl, destination);

      newFormElements.push(contentElement);
      newForm.formElements = newFormElements;
    } else if (element) {
      element.sortOrder = destination.index;
      element.formId = form.formId;
      element.languageCode = form.languageCode;
      element.contentId = securityHelper.createGuid();
      element.page = form.currentPage;
      element.data = typeof element.data === "object" ? element.data : JSON.parse(element.data);

      newFormElements.push(element);
      newForm.formElements = newFormElements;
    }
    dispatch(formActions.softUpdate(newForm));
  };
  onDragEnd = (result) => {
    const { destination, source, draggableId } = result;
    const { form, elements, dispatch } = this.props;
    if (!destination) {
      return;
    } else if (elements === undefined) {
      return;
    } else if (destination.droppableId === source.droppableId && destination.index === source.index) {
      return;
    } else if (destination.droppableId === "content" && source.droppableId === "content") {
      this.sortElements(result);
    } else if (destination.droppableId.includes("content") && source.droppableId.includes("sidebar")) {
      this.moveElement(result);
    } else if (destination.droppableId.includes("column") && source.droppableId.includes("sidebar")) {
      const newForm = containerHelper.addTo(form, sourceTypes.FORM, elements, result);
      dispatch(formActions.softUpdate(newForm));
      const containerId = destination.droppableId.slice(destination.droppableId.lastIndexOf("-") + 1, destination.droppableId.length + 1);

      dispatch(cmsActions.containerToUpdate(containerId));
    } else if (destination.droppableId.includes("column") && source.droppableId.includes("column") && destination.droppableId === source.droppableId) {
      let newForm = containerHelper.sort(form, result);
      dispatch(formActions.softUpdate(newForm));
    } else if (
      (!source.droppableId.includes("sidebar") && destination.droppableId.includes("content") && source.droppableId.includes("column")) ||
      (destination.droppableId.includes("column") && source.droppableId.includes("content")) ||
      (destination.droppableId.includes("column") && source.droppableId.includes("column"))
    ) {
      let newForm = containerHelper.move(form, sourceTypes.FORM, result);
      dispatch(formActions.softUpdate(newForm));
    }
  };
  onDragStart = (result) => {
    //anroppa func
  };

  toggleEditor = (editor) => {
    this.setState({ [editor]: !this.state[editor] });
  };
  render() {
    const { alert, form } = this.props;

    const { loaded } = this.state;
    return (
      <React.Fragment>
        {!loaded && <SplashScreen />}
        {form ? (
          <DragDropContext onDragUpdate={this.onDragStart} onDragEnd={this.onDragEnd}>
            <input style={{ display: "none" }} type="text" name="fakeusernameremembered" />
            <input style={{ display: "none" }} type="password" name="fakepasswordremembered" />
            <input style={{ display: "none" }} type="email" name="fakepasswordremembered" />
            <div className="app form-editmode">
              <div className="app-body" style={{ marginTop: "0px" }} />
              {!this.state.asideOpen && <EditorToggler dir="right" color="#2f353a" text={"Add elements"} icon="fa fa-chevron-left" onToggle={() => this.toggleEditor("asideOpen")} />}

              <AppAside className="editor-aside" fixed display="lg" style={{ width: "320px" }} className={this.state.asideOpen ? "aside-show" : "aside-hide"}>
                <Suspense fallback={this.loading()}>
                  <div ref={(r) => (this.asideEditorRef = r)}>
                    <EditorSidebar toggleConditionModal={this.toggleConditionModal} restoreDragElement />
                  </div>
                </Suspense>
              </AppAside>

              <main
                style={{ marginLeft: this.state.asideOpen ? "320px" : "0px" }}
                className=" not-inflicted editor-content" /* style={{margin: '0px !important'}} */ /* style={{ marginLeft: '250px' }} */
              >
                <div className="animated fadeIn">
                  <Container fluid style={{ padding: "0px" }}>
                    <Suspense fallback={this.loading()}>
                      <TemplateWrapper>
                        <FormContent
                          sidebarRef={this.sidebarRef}
                          asideEditorRef={this.asideEditorRef}
                          isConditionModalOpen={this.state.isConditionModalOpen}
                          conditionAction={this.state.conditionAction}
                          toggleConditionModal={this.toggleConditionModal}
                          /*       dragging={this.state.dragging} */
                        />
                      </TemplateWrapper>
                    </Suspense>
                  </Container>
                </div>
              </main>
            </div>
            {alert.type ? <Notifier message={alert.message} type={alert.type} /> : null}
          </DragDropContext>
        ) : null}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
    alert: state.alert,
    form: state.form,
    template: state.template,
    elements: state.element.elements,
    language: state.language,
    systemLabel: state.systemLabel,
  };
}
export default connect(mapStateToProps)(FormLayout);
